import OrderIcon from 'components/custom-icon/OrderIcon';
import OrderConfirmedIcon from 'components/custom-icon/OrderConfirmedIcon';
import OrderCancelledIcon from 'components/custom-icon/OrderCancelledIcon';
import OrderChangedIcon from 'components/custom-icon/OrderChangedIcon';
import OrderRedatedIcon from 'components/custom-icon/OrderRedatedIcon';
import OrderPlannedIcon from 'components/custom-icon/OrderPlannedIcon';
import SmsSendIcon from 'components/custom-icon/SmsSendIcon';



interface OrderIconsProps {
	existDelivery: boolean;
	existShipment: boolean;
	isRedated: boolean;
	isCancelled: boolean;
	isReduced: boolean;
	isDelivered: boolean;
	smsWasSend: boolean;
}


export const OrderIcons = (props: OrderIconsProps) => {
	const { existDelivery, existShipment, isRedated, isCancelled, isReduced, isDelivered, smsWasSend } = props;


	const getState = () => {
		if (isCancelled) return ' state-danger';
		if (isReduced) return ' state-warning';
		if (isDelivered) return ' state-success';
		return '';
	};

	const getIcon = () => {
		if (existShipment && existDelivery) return <OrderPlannedIcon />;
		if (existDelivery) return <OrderConfirmedIcon />;
		return <OrderIcon />;
	};

	const getTypeIcon = () => {
		if (isCancelled) return <OrderCancelledIcon />;
		if (isReduced) return <OrderChangedIcon />;
		if (isRedated) return <OrderRedatedIcon />;
		return <></>;
	};

	if (isDelivered) return (
		<></>
	)

	return (
		<p className={`component-order-icons${getState()}`}>
			{getIcon()}

			{getTypeIcon()}

			{smsWasSend && <SmsSendIcon />}
		</p>
	)
}